import { render, staticRenderFns } from "./beneficiary.vue?vue&type=template&id=c9b10616&scoped=true&lang=html&"
import script from "./beneficiary.vue?vue&type=script&lang=js&"
export * from "./beneficiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b10616",
  null
  
)

export default component.exports